import React from 'react';
import InfoIcon from '@mui/icons-material/Info';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import { red, yellow, blue } from '@mui/material/colors';

type SeveritIconProps = {
  severity: 'Error' | 'Warning' | 'Information';
  style?: React.CSSProperties;
};

const SeverityIcon = (props: SeveritIconProps) => {
  if (props.severity === 'Error')
    return <ErrorIcon style={{ ...props.style, color: red[500] }} />;
  if (props.severity === 'Warning')
    return <WarningIcon style={{ ...props.style, color: yellow[700] }} />;
  return <InfoIcon style={{ ...props.style, color: blue[300] }} />;
};

export default SeverityIcon;
